<template>
	<b-row>
		<b-col cols="12" xl="10">
			<b-card no-header>
				<template slot="header">
					User id: {{ $route.params.id }}
				</template>
				<b-table striped small fixed responsive="sm" :items="makeUserDetails" :fields="fields">
					<template slot="value" slot-scope="data">
						<strong>{{data.item.value}}</strong>
					</template>
				</b-table>
				<template slot="footer">
					<b-button @click="goBack">Back</b-button>
					<b-button class="btn-danger" @click="deleteUser">Delete</b-button>
				</template>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'User',
		props: {
			caption: {
				type: String,
				default: 'User id'
			},
		},
		data: () => {
			return {
				items: (id) => {
					const user = usersData.find(user => user.id.toString() === id)
					const userDetails = user ? Object.entries(user) : [['id', 'Not found']]
					return userDetails.map(([key, value]) => {
						return {key: key, value: value}
					})
				},
				fields: [
					{key: 'key'},
					{key: 'value'},
				],
			}
		},
		// computed: {
		// 	...mapGetters('users',[
		// 		'getSingeuser'
		// 	])
		// },
		methods: {
			goBack() {
				this.$router.push('/users');
				// this.$router.replace({path: '/users'})
			},
			...mapActions('users', [
				'deleteUserWithId'
			]),
			async deleteUser() {
				await this.deleteUserWithId(this.$route.params.id)
				this.$router.push('/users');
				// this.$router.replace({path: '/users'})
			},
			makeUserDetails (user) {
				let userDetails = user ? Object.entries(user) : [['id', 'Not found']];
				return userDetails.map(([key, value]) => {
					return {key: key, value: value};
				})
			}
		},
		mounted() {
			this.makeUserDetails(this.user(this.$route.params.id))
		}
	}
</script>
